import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
  path: 'B2C/:brandname/:tillid',
  loadChildren: './modules/home/home.module#HomeModule',
  pathMatch: 'full'
  },
  {
    path: '',
    loadChildren: './modules/home/home.module#HomeModule',
    pathMatch: 'full'
  },
  {
    path: 'search',
    loadChildren: './modules/search/search.module#SearchModule',
    pathMatch: 'full'
    },
  {
    path: 'otp',
    loadChildren: './modules/otp/otp.module#OtpModule',
  },
  {
    path: 'register',
    loadChildren: './modules/register/register.module#RegisterModule',
  },
  {
    path: 'name',
    loadChildren: './modules/name/name.module#NameModule',
  },
  {
    path: 'email',
    loadChildren: './modules/email/email.module#EmailModule',
  },
  {
    path: 'age',
    loadChildren: './modules/age/age.module#AgeModule',
  },
  {
    path: 'anniversary',
    loadChildren: './modules/anniversary/anniversary.module#AnniversaryModule',
  },
  {
    path: 'country',
    loadChildren: './modules/country/country.module#CountryModule',
  },
  {
    path: 'gender',
    loadChildren: './modules/sex/sex.module#SexModule',
  },
  {
    path: 'interest',
    loadChildren: './modules/interest/interest.module#InterestModule',
  },
  {
    path: 'privacy-policy',
    loadChildren: './modules/privacy/privacy.module#PrivacyModule',
  },
  {
    path: 'communication',
    loadChildren: './modules/communication/communication.module#CommunicationModule',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
